import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  titleContainer: {
    flexDirection: "column",
    marginTop: 24,
  },
  reportTitle: {
    fontSize: 12,
    textAlign: "center",
    textTransform: "uppercase",
  },
});

const InvoiceThankYouMsg = () => (
  <View style={styles.titleContainer}>
    <Text style={styles.reportTitle}>Thank you for doing business with us</Text>
    <Text style={styles.reportTitle}>************************************</Text>
    <Text style={styles.reportTitle}>
      Please refer to our website for additional terms and conditions, and
      moving tips
    </Text>
  </View>
);

export default InvoiceThankYouMsg;
